import { C } from '../../../styles/tokens';

const TABLE_HEADERS = [
    { label: 'Title',    cls: '' },
    { label: 'Duration', cls: 'ct-col-duration' },
    { label: 'Created',  cls: 'ct-col-created' },
    { label: 'Status',   cls: '' },
    { label: '',         cls: '' },
];

// Matches Content.js's real table exactly (used by ContentVoiceOver + ContentAudioArticle) —
// shared so RouteSkeleton can reuse this for the hard-refresh case too.
export default function ContentTableSkeleton() {
    return (
        <div style={{ background: C.w, border: `1px solid ${C.n200}`, borderRadius: 13, overflow: 'hidden' }}>
            <div className="content-table-row" style={{
                padding: '9px 16px', borderBottom: `1px solid ${C.n200}`, background: '#FAFAFA',
            }}>
                {TABLE_HEADERS.map((h, i) => (
                    <div key={i} className={h.cls} style={{ fontSize: 11.5, fontWeight: 600, color: C.n400, letterSpacing: '.03em' }}>{h.label}</div>
                ))}
            </div>
            {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="content-table-row" style={{
                    padding: '12px 16px', alignItems: 'center',
                    borderBottom: i < 4 ? `1px solid ${C.n100}` : 'none',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div className="shine" style={{ width: 32, height: 32, borderRadius: 7, flexShrink: 0 }} />
                        <div>
                            <div className="shine rounded-2" style={{ height: 13, width: 160, marginBottom: 5 }} />
                            <div className="shine rounded-2" style={{ height: 10, width: 55 }} />
                        </div>
                    </div>
                    <div className="ct-col-duration shine rounded-2" style={{ height: 12, width: 36 }} />
                    <div className="ct-col-created shine rounded-2" style={{ height: 12, width: 70 }} />
                    <div className="shine rounded-5" style={{ height: 20, width: 65 }} />
                    <div />
                </div>
            ))}
        </div>
    );
}
